var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":"","id":_vm.id,"size":"sm","variant":"info","pill":""}},[_c('b-icon-question-circle-fill',{attrs:{"aria-hidden":"true"}})],1),_c('b-popover',{attrs:{"target":_vm.id,"triggers":"hover"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }